import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './Dark_Blue_Btn.css'

const Dark_Blue_Btn = ({onClick,leftIcon,btn_name,rightIcon}) => {
    return (
        <button className="Dark_Blue_Btn" onClick={onClick} type='button'>
            {leftIcon && (
                <div className='icon_holder'>
                    <FontAwesomeIcon icon={leftIcon} className='left_icon' />
                </div>
            )}

            <p className='btn_text'>{btn_name}</p>

            {rightIcon && (
                <div className='icon_holder'>
                    <FontAwesomeIcon icon={rightIcon} className='right_icon' />
                </div>
            )}
        </button>
    )
}

export default Dark_Blue_Btn
